export const type = 'session/sync';

export default () => ({
  type,
  error: false,
});
